/* global debounce */
import { LottieAnimator } from '~bergBlockPath/lottie-animator/js/core-event-handler';

class LottieSequence {

  constructor( settings ) {
    this.settings = settings;
    this.lottieQueue = [];
    this.observerOptions = {
      root: null,
      rootMargin: settings.rootMargin,
      threshold: !this.isMobile() ? settings.threshold : settings.mobileThreshold,
    };
  }

  isMobile() {
    return window.matchMedia( `(max-width: ${this.settings.mobileBreakpoint}px)` ).matches;
  }

  addLottieToQueue ( lottie ) {
    let no = $( lottie ).data( 'lottie-sequence' );
    if ( no === undefined ) {
      const animator = new LottieAnimator( lottie );
      animator.init();
      no = this.lottieQueue.length;
      $( lottie ).attr( 'data-lottie-sequence', no );
      this.lottieQueue.push( animator );
    }
    return this.lottieQueue[no];
  }

  initiateLotties ( lotties ) {
    lotties.each( ( i, lottie ) => this.addLottieToQueue( lottie ) );
  }

  animateLotties ( lotties ) {
    const animatorChain = [];
    const animateLottie = chainObject => {
      if ( !chainObject ) {
        return;
      }
      const lottieAnimation = chainObject.animator.lottieAnimation;
      lottieAnimation.goToAndStop( 0, true );
      lottieAnimation.play();
      lottieAnimation.addEventListener(
        'complete',
        ( () => {
          const nextAnimator = debounce( () => {
            animateLottie( chainObject.next );
          }, this.settings.sequenceInterval );
          lottieAnimation.removeEventListener( 'complete' );
          return nextAnimator;
        } )()
      );
    };

    lotties.each( ( i, lottie ) => {
      const chainObject = {
        animator: this.addLottieToQueue( lottie ),
      };
      if ( i > 0 ) {
        animatorChain[i - 1].next = chainObject;
      }
      animatorChain.push( chainObject );
    } );

    if ( animatorChain.length === 0 ) return;
    if ( this.settings.circular ) {
      animatorChain[animatorChain.length - 1].next = animatorChain[0];
    }
    animateLottie( animatorChain[0] );
  }

  init( element ) {
    if ( this.isMobile() && !this.settings.mobile ) return;
    const $element = $( element );
    const lotties = $element.find( '.bs-lottie-animator' );
    this.initiateLotties( lotties );

    const observer = new IntersectionObserver( entries => {
      if ( entries[0].isIntersecting ) {
        this.animateLotties( lotties );
        observer.disconnect();
      }
    }, this.observerOptions );

    observer.observe( element );
  }

}

$.fn.lottieSequence = function ( options ) {
  const settings = $.extend(
    {
      sequenceInterval: 0,
      circular: false,
      rootMargin: '0px 0px -15px 0px',
      threshold: 0,
      mobileThreshold: 0,
      mobile: true,
      mobileBreakpoint: 767.98,
    },
    options
  );

  $( this ).each( ( i, element ) => {
    const lottieSequence = new LottieSequence( settings );
    lottieSequence.init( element );
  } );
};

$( '.bs-section--counter-section' ).lottieSequence( {
  sequenceInterval: 900,
  circular: true,
} );
$( '.bs-section--features-with-three-blurbs .bs-column--content-wrapper' ).lottieSequence( {
  sequenceInterval: 900,
  circular: true,
  threshold: 1,
  mobileThreshold: 0.5,
} );
$( '.bs-section--features-with-four-blurbs .bs-column--content-wrapper' ).lottieSequence( {
  sequenceInterval: 900,
  circular: true,
  threshold: 1,
  mobile: false,
} );
$( '.bs-section--pricing-how-does-work' ).lottieSequence( {
  sequenceInterval: 900,
  circular: true,
} );
$( '.bs-section--about-better-workflows' ).lottieSequence( {
  sequenceInterval: 900,
  circular: true,
} );
$( '.bs-section--pricing-counter' ).lottieSequence( {
  sequenceInterval: 900,
  circular: true,
} );
$( '.bs-div--blog-standard-inner-media-block' ).lottieSequence( {
  sequenceInterval: 2000,
  circular: true,
} );
